import { ActionContext } from "vuex";
import { FeedbackService } from "../services/FeedbackService";

const state = {
  isOpen: false,
  isError: false,
  isLoading: false
};

type State = typeof state;

const getters = {
  isLoading: (state: State) => state.isLoading,
  isOpen: (state: State) => state.isOpen,
  isError: (state: State) => state.isError
};

const actions = {
  loading(context: ActionContext<State, unknown>) {
    context.commit("LOADING");
  },
  success(context: ActionContext<State, unknown>) {
    context.commit("SUCCESS");
  },
  error(context: ActionContext<State, unknown>) {
    context.commit("ERROR");
  },
  submitFeedback(context: ActionContext<State, unknown>, payload: string) {
    context.commit("LOADING");
    FeedbackService.addFeedback(payload)
      .then(() => {
        context.commit("SUCCESS");
        context.commit("TOGGLE", false);
      })
      .catch(() => context.commit("ERROR"));
  },
  open(context: ActionContext<State, unknown>) {
    context.commit("TOGGLE", true);
  },
  close(context: ActionContext<State, unknown>) {
    context.commit("TOGGLE", false);
    context.commit("RESET");
  },
  reset(context: ActionContext<State, unknown>) {
    context.commit("RESET");
  }
};

const mutations = {
  LOADING(state: State) {
    state.isLoading = true;
  },
  SUCCESS(state: State) {
    state.isLoading = false;
  },
  ERROR(state: State) {
    state.isLoading = false;
    state.isError = true;
  },
  TOGGLE(state: State, payload: boolean) {
    state.isOpen = payload;
  },
  RESET(state: State) {
    state.isError = false;
    state.isLoading = false;
  }
};

const Feedback = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default Feedback;
